export interface DemoTourStep {
  readonly title: string;
  readonly body: readonly string[];
  /** Reference-only. Never copied into the editor automatically */
  readonly referenceCode?: string;
}

export const DEMO_TOUR_STEPS: readonly DemoTourStep[] = [
  {
    title: "Welcome",
    body: [
      "This workspace is your lesson editor and console in one place.",
      "Use the instructions here while you work. Nothing on this panel writes code for you.",
    ],
  },
  {
    title: "Run your program",
    body: [
      "Press Run to execute main.py in your browser with Pyodide.",
      "When the program asks a question, type in the console box and press Submit.",
    ],
    referenceCode:
      '# Try running this shape:\nprint("Hello!")\nname = input("Name? ")\nprint(f"Hi, {name}!")',
  },
  {
    title: "Read the console",
    body: [
      "Stdout and stderr appear in the Console panel.",
      "Stop halts a run; Clear console wipes output without changing your file.",
    ],
  },
  {
    title: "Save & iterate",
    body: [
      "Your file autosaves locally in this browser.",
      "Watch the header for Saved / Unsaved. Blur away from the editor flushes the latest text.",
    ],
  },
  {
    title: "Check My Work",
    body: [
      "When your work is ready, Check My Work runs the lesson’s automated checks on your main.py in the browser.",
      "You only see each check’s name and whether it passed, plus short hints when something fails. The test code itself stays private.",
      "On a real class assignment, your attempt is also saved so your teacher can see progress (when submission storage is enabled).",
    ],
  },
];
